import { Grid, Box, Button, Modal, makeStyles, Checkbox } from '@material-ui/core';
import moment from 'moment';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { Form } from 'react-final-form';
import { useDispatch, useSelector } from 'react-redux';
import { v4 as uuid } from 'uuid';
import axios from 'axios';
import { useKeycloak } from '@react-keycloak/web';
import QCXFocusLock from '../../../../../../components/focus-lock/QCXFocusLock';
import QCXFormSubtitle from '../../../../../../components/form-title/QCXFormSubtitle';
import { setErrorFeedback, setSuccessFeedback } from '../../../../../../features/feedback/feedbackSlice';
import QCXErrorAlert from '../../../../../../shared-components/alert/QCXErrorAlert';
import QCXDataGrid from '../../../../../../shared-components/data-grid/QCXDataGrid';
import QCXFinalDateTimePickerField from '../../../../../../shared-components/final-date-time-picker-field/QCXFinalDateTimePickerField';
import QCXSelectClienteAutocomplete from '../../../../../../shared-components/final-select-cliente-field/QCXSelectClienteAutocomplete';
import QCXFinalTextField from '../../../../../../shared-components/final-text-field/QCXFinalTextField';
import QCXForm from '../../../../../../shared-components/form/QCXForm';
import QCXSelectDespachanteAutocomplete from '../../../../../../shared-components/select-despachante/QCXSelectDespachanteAutocomplete';
import { doPostQCXRequest } from '../../../../../../utils/api/domain/domain-api-utils';
import SelectCatalogoProdutosSituacao from './SelectCatalogoProdutosSituacao';
import FileDragAndDrop from '../../../../../../ts/common/components/fileDragAndDrop';
import { selectUnidadeSelecionada } from '../../../../../../features/usuario-logado/usuarioLogadoSlice';
import { loading, success } from '../../../../../../features/catalogo-produtos/catalogoProdutosSlice';
import QCXWarningAlert from '../../../../../../shared-components/alert/QCXWarningAlert';
import QCXSelectNcmSubItemAutocomplete from '../../../../../../shared-components/select-ncm-subitem/QCXSelectNcmSubItemAutocomplete';
import QCXSelectPaisAutocomplete from '../../../../../../shared-components/select-pais/QCXSelectPaisAutocomplete';

const useStyles = makeStyles({
  modalContent: {
    width: '90%',
    maxWidth: 1400,
    maxHeight: '80vh',
    padding: '20px',
    backgroundColor: 'white',
    borderRadius: '4px',
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    justifyContent: 'flex-start',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    overflowY: 'scroll',
  },
  uploadButton: {
    display: 'inline',
    background: 'none',
    border: 'none',
    padding: '0px',
    fontWeight: '600',
    textDecoration: 'underline',
    color: '#0000FF',
    cursor: 'pointer',
  },
  submitButtonsBox: {
    marginTop: '20px',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  uploadSubmitBox: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
  },
  avisoVinculosButton: {
    border: 'none',
    background: 'none',
    cursor: 'pointer',
  },
  innerModal: {
    zIndex: 999999,
    backgroundColor: 'rgba(0, 0, 0, 0.1)',
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 4,
  },
  innerModalContent: {
    maxWidth: 800,
    backgroundColor: 'white',
    padding: '24px',
    borderRadius: 4,
  },
  avisoVinculosTextArea: {
    width: '100%',
  },
});

export default function CatalogoProdutosRecuperarPorCnpjModal({ isModalOpen, closeModal, refetchCatalogoProdutos }) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { keycloak } = useKeycloak();
  const { token } = keycloak;
  keycloak.updateToken(10);

  const selectedUnidade = useSelector(selectUnidadeSelecionada);

  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [clienteId, setClienteId] = useState(null);
  const [despachanteId, setDespachanteId] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [showAvisoVinculos, setShowAvisoVinculos] = useState(false);
  const [showProdutoCandidates, setShowProdutoCandidates] = useState(false);
  const [listaProdutoCandidates, setListaProdutoCandidates] = useState([]);
  const [showUpload, setShowUpload] = useState(false);
  const [file, setFile] = useState(null);
  const [selectedMap, setSelectedMap] = useState({});
  const selectedAmount = useMemo(() => Object.keys(selectedMap).length, [selectedMap]);
  const allChecked = selectedAmount === listaProdutoCandidates.length;

  const [hideLimitMessage, setHideLimitMessage] = useState(true);

  const partnumbersSemVinculo = useMemo(
    () =>
      listaProdutoCandidates
        .filter((c) => (c.opes ?? []).length === 0 && !!c.produto?.codigosInterno?.[0] && !!c.produto?.codigo)
        .map((c) => `${c.produto.seq} ${c.produto?.codigosInterno?.[0]} - ${c.produto?.codigo}`),
    [listaProdutoCandidates]
  );
  const partnumbersSemVinculoText = partnumbersSemVinculo.join('\n');

  useEffect(() => {
    if (!isModalOpen) {
      setConfirmationOpen(false);
      setSubmitting(false);
      setShowProdutoCandidates(false);
      setShowAvisoVinculos(false);
      setListaProdutoCandidates([]);
      setShowUpload(false);
      setSelectedMap({});
      setHideLimitMessage(true);
    }
  }, [isModalOpen]);

  const handleConfirm = async (data) => {
    setSubmitting(true);
    setShowProdutoCandidates(true);
    setShowUpload(false);
    setListaProdutoCandidates([]);
    setHideLimitMessage(true);

    const body = {
      clienteId: data.cliente,
      despachanteId: data.despachante,
    };
    setClienteId(data.cliente);
    setDespachanteId(data.despachante);

    if (data.codigo) body.codigo = data.codigo;
    if (data.codigoInterno) body.codigoInterno = data.codigoInterno;
    if (data.denominacao) body.denominacao = data.denominacao;
    if (data?.ncm?.id && data?.ncm?.id > 0) body.ncmId = data.ncm.id;
    if (data?.pais?.id && data?.pais?.id > 0) body.paisId = data.pais.id;
    if (data.dataRegistroInicio) body.dataRegistroInicio = moment(data.dataRegistroInicio).format('YYYY-MM-DD');
    if (data.dataRegistroFim) body.dataRegistroFim = moment(data.dataRegistroFim).format('YYYY-MM-DD');
    if (data.dataInicio) body.dataInicio = moment(data.dataInicio).format('YYYY-MM-DD');
    if (data.dataFim) body.dataFim = moment(data.dataFim).format('YYYY-MM-DD');
    if (data.situacao) body.situacao = data.situacao;

    if (
      data.codigo ||
      data.codigoInterno ||
      data.denominacao ||
      data.dataRegistroFim ||
      data.dataRegistroInicio ||
      data.dataInicio ||
      data.dataFim ||
      data?.ncm?.id ||
      data?.pais?.id
    ) {
      setHideLimitMessage(false);
    }

    try {
      const response = await doPostQCXRequest(
        ['catalogoprodutos', 'list-recuperacao-catalogo-produtos-candidates'],
        body
      );

      if (response.status === 200) {
        response.data?.forEach?.((p) => {
          p.id = uuid();
        });
        const candidates = response.data ?? [];
        candidates.sort((a, b) => a.produto.seq - b.produto.seq);
        setListaProdutoCandidates(candidates);
      }
    } catch (error) {
      let errorMessage = 'Erro ao consultar catalogo de produtos do portal único';
      if (error?.response?.data?.hasError && error?.response?.data?.message) {
        errorMessage = error?.response?.data?.message;
      }

      dispatch(
        setErrorFeedback({
          message: errorMessage,
        })
      );
    } finally {
      setSubmitting(false);
      setShowProdutoCandidates(true);
    }
  };

  const submitFile = useCallback(async () => {
    try {
      if (!file) {
        dispatch(setErrorFeedback({ message: 'Selecione um arquivo.' }));
        return;
      }

      dispatch(loading());

      const formData = new FormData();
      formData.append('file', file);

      const url = `${process.env.REACT_APP_QCX_API_BASE_URL}/catalogoprodutos/integrar-arquivo-catalogo-produtos?clienteId=${clienteId}&despachanteId=${despachanteId}`;
      const response = await axios.post(url, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
          quickcomextenant: selectedUnidade,
        },
      });

      if (response.status > 199 && response.status < 300) {
        dispatch(
          setSuccessFeedback({
            message: 'Catalogo de produtos recuperado com sucesso.',
          })
        );
        closeModal();
        refetchCatalogoProdutos?.();
      } else {
        throw new Error('Status inesperado.');
      }
    } catch (error) {
      let errorMessage = 'Erro ao enviar arquivo';
      if (typeof error?.response?.data === 'string') {
        errorMessage = error.response.data;
      }

      dispatch(
        setErrorFeedback({
          message: errorMessage,
        })
      );
    } finally {
      dispatch(success());
    }
  }, [file, clienteId, despachanteId, closeModal]);

  const submitSelected = useCallback(async () => {
    try {
      if (!confirmationOpen && partnumbersSemVinculo.length > 0) {
        setConfirmationOpen(true);

        return;
      }

      dispatch(loading());

      const body = listaProdutoCandidates.filter((p) => !!selectedMap[p.id]);
      const queryParams = [{ name: 'clienteId', value: clienteId }];
      const response = await doPostQCXRequest(
        ['catalogoprodutos', 'integrar-recuperacao-catalogo-produtos-candidates'],
        body,
        queryParams
      );

      if (response.status > 199 && response.status < 300) {
        dispatch(
          setSuccessFeedback({
            message: 'Catalogo de produtos recuperado com sucesso.',
          })
        );
        closeModal();
        refetchCatalogoProdutos?.();
      } else {
        throw new Error('Status inesperado.');
      }
    } catch (error) {
      let errorMessage = 'Erro ao recuperar catalogo de produtos';
      if (typeof error?.response?.data === 'string') {
        errorMessage = error?.response?.data;
      }

      dispatch(
        setErrorFeedback({
          message: errorMessage,
        })
      );
    } finally {
      dispatch(success());
    }
  }, [listaProdutoCandidates, selectedMap, clienteId, partnumbersSemVinculo, confirmationOpen, closeModal]);

  const handleRecuperarCheckboxChange = (evt, key) => {
    setSelectedMap((prevMap) => {
      if (evt.target.checked) prevMap[key] = true;
      else delete prevMap[key];

      return { ...prevMap };
    });
  };

  const handleSelecionarTodos = () => {
    if (allChecked) {
      setSelectedMap({});
    } else {
      const newSelectedMap = {};
      listaProdutoCandidates.forEach((p) => {
        newSelectedMap[p.id] = true;
      });
      setSelectedMap(newSelectedMap);
    }
  };

  const columns = useMemo(
    () => [
      {
        field: 'recuperar',
        headerName: 'Recuperar',
        width: 130,
        renderCell: ({ row }) => (
          <Checkbox
            key={String(selectedMap[row.id])}
            checked={selectedMap[row.id]}
            onChange={(evt) => handleRecuperarCheckboxChange(evt, row.id)}
          />
        ),
      },
      {
        field: 'seq',
        headerName: 'Seq.',
        width: 90,
        valueGetter: ({ row }) => row?.produto?.seq ?? '-',
      },
      {
        field: 'partnumber',
        headerName: 'Partnumber',
        flex: 1,
        valueGetter: ({ row }) => row?.produto?.codigosInterno?.[0] ?? '-',
      },
      {
        field: 'ncm',
        headerName: 'NCM',
        width: 140,
        valueGetter: ({ row }) => row?.produto?.ncm ?? '-',
      },
      {
        field: 'codigo',
        headerName: 'Código',
        width: 120,
        valueGetter: ({ row }) => row?.produto?.codigo ?? '-',
      },
      {
        field: 'situacao',
        headerName: 'Situação',
        width: 130,
        valueGetter: ({ row }) => row?.produto?.situacao ?? '-',
      },
      {
        field: 'ope',
        headerName: 'OPE',
        flex: 1,
        valueGetter: ({ row }) => ((row?.opes ?? []).length > 0 ? row.opes[0]?.nome : '-'),
      },
      {
        field: 'codigo_ope',
        headerName: 'Código OPE',
        width: 150,
        valueGetter: ({ row }) => ((row?.opes ?? []).length > 0 ? row.opes[0]?.codigo : '-'),
      },
      {
        field: 'pais',
        headerName: 'País',
        width: 150,
        valueGetter: ({ row }) => ((row?.opes ?? []).length > 0 ? row.opes[0]?.codigoPais : '-'),
      },
    ],
    [selectedMap]
  );

  return (
    <Modal open={isModalOpen} onClose={closeModal}>
      <QCXFocusLock style={{ width: '100%' }}>
        <div className={classes.modalContent}>
          <Box width="100%">
            <h2>Recuperar produtos do portal único</h2>

            <Form onSubmit={handleConfirm} initialValues={{ situacao: '0' }}>
              {({ values, handleSubmit }) => (
                <QCXForm onSubmit={handleSubmit}>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <QCXSelectClienteAutocomplete id="cliente" name="cliente" label="Cliente" required />
                    </Grid>
                    <Grid item xs={6}>
                      <QCXSelectDespachanteAutocomplete
                        label="Despachante"
                        name="despachante"
                        required
                        disabled={!values?.cliente}
                        clienteId={values?.cliente}
                        useFirstAsDefault={!!values?.cliente}
                      />
                    </Grid>

                    <Grid item xs={3}>
                      <QCXFinalTextField
                        id="codigo"
                        key="codigo"
                        name="codigo"
                        label="Código"
                        maxLength={10}
                        disabled={!values?.cliente}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <QCXFinalTextField
                        id="codigoInterno"
                        key="codigoInterno"
                        name="codigoInterno"
                        label="Código interno"
                        maxLength={60}
                        disabled={!values?.cliente}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <QCXFinalTextField
                        id="denominacao"
                        name="denominacao"
                        label="Denominação"
                        maxLength={3700}
                        disabled={!values?.cliente}
                      />
                    </Grid>

                    <Grid item xs={3}>
                      <QCXSelectNcmSubItemAutocomplete id="ncm" name="ncm.id" label="NCM" disabled={!values?.cliente} />
                    </Grid>
                    <Grid item xs={3}>
                      <SelectCatalogoProdutosSituacao
                        id="situacao"
                        label="Situação"
                        name="situacao"
                        disabled={!values?.cliente}
                        defaultValue="1"
                        required
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <QCXFinalDateTimePickerField
                        id="dataRegistroInicio"
                        name="dataRegistroInicio"
                        label="Registro - Data inicial"
                        disabled={!values?.cliente}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <QCXFinalDateTimePickerField
                        id="dataRegistroFim"
                        name="dataRegistroFim"
                        label="Registro - Data final"
                        disabled={!values?.cliente}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <QCXFinalDateTimePickerField
                        id="dataInicio"
                        name="dataInicio"
                        label="Última alteração - Data inicial"
                        disabled={!values?.cliente}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <QCXFinalDateTimePickerField
                        id="dataFim"
                        name="dataFim"
                        label="Última alteração - Data final"
                        disabled={!values?.cliente}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <QCXSelectPaisAutocomplete
                        autoLoad
                        id="pais"
                        name="pais.id"
                        label="País"
                        disabled={!values?.cliente}
                      />
                    </Grid>
                  </Grid>

                  <Box className={classes.submitButtonsBox}>
                    <Button variant="outlined" color="default" onClick={closeModal}>
                      Fechar
                    </Button>
                    <Button disabled={submitting} type="submit" variant="contained" color="secondary">
                      Confirmar
                    </Button>
                  </Box>
                </QCXForm>
              )}
            </Form>
          </Box>

          {showProdutoCandidates && !showUpload ? (
            <Grid container spacing={2} style={{ marginTop: 24 }}>
              <Grid item xs={12}>
                <QCXFormSubtitle title="Catalogos para recuperar" />
              </Grid>

              <Grid item xs={12}>
                {!hideLimitMessage && listaProdutoCandidates.length > 500 ? (
                  <QCXErrorAlert>
                    A consulta retornou mais de 500 produtos. Para ver todo o catálogo, remova os filtros aplicados ou{' '}
                    <button onClick={() => setShowUpload(true)} className={classes.uploadButton} type="button">
                      faça upload
                    </button>{' '}
                    do arquivo exportado do Portal Único.
                  </QCXErrorAlert>
                ) : null}
              </Grid>

              <Grid item xs={12}>
                <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Box style={{ display: 'flex', alignItems: 'center' }}>
                    <Checkbox
                      checked={selectedAmount > 0 && allChecked}
                      onChange={handleSelecionarTodos}
                      disabled={submitting || listaProdutoCandidates.length === 0}
                    />
                    <p style={{ lineHeight: 0 }}>Selecionar todos</p>
                  </Box>

                  <button
                    onClick={() => setShowAvisoVinculos(true)}
                    className={classes.avisoVinculosButton}
                    type="button"
                  >
                    {partnumbersSemVinculo.length > 0 ? (
                      <QCXWarningAlert>
                        {partnumbersSemVinculo.length} produto(s) sem vínculo com Operador Estrangeiro.
                      </QCXWarningAlert>
                    ) : null}
                  </button>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <QCXDataGrid loading={submitting} columns={columns} rows={listaProdutoCandidates} />
              </Grid>
              <Grid item xs={12}>
                <Box style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <span>{selectedAmount} produto(s) selecionado(s) para recuperação.</span>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box className={classes.uploadSubmitBox}>
                  <Button
                    disabled={submitting || selectedAmount === 0}
                    onClick={submitSelected}
                    variant="contained"
                    color="secondary"
                  >
                    Integrar
                  </Button>
                </Box>
              </Grid>
            </Grid>
          ) : null}

          {showProdutoCandidates && showUpload ? (
            <Grid container spacing={2} style={{ marginTop: 24 }}>
              <Grid item xs={12}>
                <QCXFormSubtitle title="Integrar todo Catalogo de Produtos" />
              </Grid>

              <Grid item xs={12}>
                <p>
                  O arquivo do Catalogo de Produtos pode ser exportado no site do Portal Único Siscomex em:
                  &quot;Catalogo de Produtos&quot; &gt; &quot;Produto&quot; &gt; &quot;Exportar&quot; &gt;
                  &quot;Produtos&quot;. Faça upload do arquivo zip ou json.
                </p>
              </Grid>

              <Grid item xs={12}>
                <FileDragAndDrop onChangeAction={(_, f) => setFile(f)} accept="application/json, application/zip" />
              </Grid>

              <Grid item xs={12}>
                <Box className={classes.uploadSubmitBox}>
                  <Button disabled={file === null} onClick={submitFile} variant="contained" color="secondary">
                    Integrar
                  </Button>
                </Box>
              </Grid>
            </Grid>
          ) : null}
        </div>

        {showAvisoVinculos ? (
          <div className={classes.innerModal}>
            <div className={classes.innerModalContent}>
              <h2>Partnumbers sem vínculo com operador estrangeiro</h2>

              <p>Listados no formato: &quot;&lt;Sequência&gt; &lt;Partnumber&gt; - &lt;Código&gt;&quot;</p>
              <textarea
                className={classes.avisoVinculosTextArea}
                readOnly
                rows={10}
                value={partnumbersSemVinculoText}
              />

              <Button variant="outlined" color="default" onClick={() => setShowAvisoVinculos(false)}>
                Fechar
              </Button>
            </div>
          </div>
        ) : null}

        {confirmationOpen ? (
          <div className={classes.innerModal}>
            <div className={classes.innerModalContent}>
              <h2>Aviso</h2>

              <p>
                Há {partnumbersSemVinculo.length} produto(s) sem vínculo com Operador Estrangeiro. Certeza que deseja
                continuar?
              </p>

              <Box display="flex" justifyContent="flex-end" alignItems="center" width="100%">
                <Button variant="outlined" color="primary" onClick={() => setConfirmationOpen(false)}>
                  Cancelar
                </Button>
                <Button variant="contained" color="secondary" onClick={submitSelected}>
                  Confirmar
                </Button>
              </Box>
            </div>
          </div>
        ) : null}
      </QCXFocusLock>
    </Modal>
  );
}
